var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_784_35928",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.337646,
    y: 0.602875,
    width: 21.634,
    height: 21.634,
    fill: "#979193"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_784_35928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_2",
    d: "M6.92544 19.0819C6.47589 19.0819 6.09192 18.9227 5.77354 18.6043C5.45515 18.286 5.29595 17.902 5.29595 17.4524V6.01139H4.39453V4.65929H8.45089V3.86189H13.8594V4.65929H17.9158V6.01139H17.0143V17.4524C17.0143 17.9078 16.8566 18.2932 16.5411 18.6087C16.2256 18.9242 15.8402 19.0819 15.3848 19.0819H6.92544ZM15.6622 6.01139H6.64805V17.4524C6.64805 17.5333 6.67406 17.5998 6.72607 17.6518C6.77808 17.7038 6.84454 17.7298 6.92544 17.7298H15.3848C15.4542 17.7298 15.5178 17.7009 15.5756 17.6432C15.6333 17.5854 15.6622 17.5218 15.6622 17.4524V6.01139ZM8.81495 15.927H10.1671V7.81423H8.81495V15.927ZM12.1432 15.927H13.4953V7.81423H12.1432V15.927Z",
    fill: "#979193"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.43e4abd165e1a205d3c2e40bc3775e0b.svg";
export { ForwardRef as ReactComponent };